import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 15,
  path: '/emergency',
  component: Home,
  redirect: '/emergency/evaluation/fuzhoucity',
  name: 'emergency',
  isHead: true,
  meta: {
    title: '应急管理',
    icon: 'el-icon-connection'
  },
  children: [
    {
      path: 'evaluation',
      component: () => import('@/views/emergency/index'),
      name: 'emergency',
      meta: { title: '应急能力评估', close: false },
      children: [ {
        path: 'fuzhoucity',
        name: 'fuzhoucity',
        component: () => import('@/views/emergency/evaluation/fuzhoucity/index'),
        meta: {title: '福州市', close: true}
      },{
        path: 'chemicals',
        name: 'chemicals',
        component: () => import('@/views/emergency/evaluation/chemicals/index'),
        meta: {title: '危险化学品', next: '/emergency/evaluation/chemicals', close: true}
      },{
        path: 'dustExplosion',
        name: 'dustExplosion',
        component: () => import('@/views/emergency/evaluation/dustExplosion/index'),
        meta: {title: '粉尘涉爆', close: true}
      },{
        path: 'moltenMetal',
        name: 'moltenMetal',
        component: () => import('@/views/emergency/evaluation/moltenMetal/index'),
        meta: {title: '熔融金属', close: true}
      }]
    },
    {
      path: 'resources',
      component: () => import('@/views/emergency/index'),
      name: 'resources',
      meta: { title: '应急资源上报', close: false },
      children: [ {
          path: 'internalInstitution',
          name: 'internalInstitution',
          component: () => import('@/views/emergency/resources/internalInstitution/index'),
          meta: {title: '内设机构', next: '/emergency/resources/internalInstitution', close: true}
        }, {
          path: 'expert',
          name: 'expert',
          component: () => import('@/views/emergency/resources/expert/index'),
          meta: {title: '应急专家', next: '/emergency/resources/expert', close: true}
        }, {
          path: 'planningDocument',
          name: 'planningDocument',
          component: () => import('@/views/emergency/resources/planningDocument/index'),
          meta: {title: '规划文件', next: '/emergency/resources/planningDocument', close: true}
        }, {
          path: 'informationization',
          name: 'informationization',
          component: () => import('@/views/emergency/resources/informationization/index'),
          meta: {title: '信息化平台建设情况', next: '/emergency/resources/informationization', close: true}
        }, {
          path: 'organization',
          name: 'organization',
          component: () => import('@/views/emergency/resources/organization/index'),
          meta: {title: '应急组织机构', next: '/emergency/resources/organization', close: true}
        }, {
          path: 'contingencyPlan',
          name: 'contingencyPlan',
          component: () => import('@/views/emergency/resources/contingencyPlan/index'),
          meta: {title: '应急预案', next: '/emergency/resources/contingencyPlan', close: true}
        }, {
          path: 'materials',
          name: 'materials',
          component: () => import('@/views/emergency/resources/materials/index'),
          meta: {title: '应急物资', next: '/emergency/resources/materials', close: true}
        },{
          path: 'teams',
          name: 'teams',
          component: () => import('@/views/emergency/resources/teams/index'),
          meta: {title: '应急队伍', next: '/emergency/resources/teams', close: true}
        },{
          path: 'fireStation',
          name: 'fireStation',
          component: () => import('@/views/emergency/resources/fireStation/index'),
          meta: {title: '消防站', next: '/emergency/resources/fireStation', close: true}
        },{
          path: 'refuge',
          name: 'refuge',
          component: () => import('@/views/emergency/resources/refuge/index'),
          meta: {title: '应急避难场所', next: '/emergency/resources/refuge', close: true}
        },{
          path: 'popularScience',
          name: 'popularScience',
          component: () => import('@/views/emergency/resources/popularScience/index'),
          meta: {title: '应急科普', next: '/emergency/resources/popularScience', close: true}
        },{
          path: 'accidentStatistics',
          name: 'accidentStatistics',
          component: () => import('@/views/emergency/resources/accidentStatistics/index'),
          meta: {title: '年度生产安全事故统计', next: '/emergency/resources/accidentStatistics', close: true}
        },{
          path: 'standardization',
          name: 'standardization',
          component: () => import('@/views/emergency/resources/standardization/index'),
          meta: {title: '标准化建设情况', next: '/emergency/resources/standardization', close: true}
        },
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/emergency.js